import { useContext } from 'react'
import styled from 'styled-components'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import FieldTitle from './field-title'
import { CreationCaptureInfoContext } from '../../supercut/shared/components/capture-info/manager'
import WatermarkPreviewItem from '../../supercut/shared/components/capture-info/watermark-preview-item'

const Container = styled.div`
    grid-column: span 2;
`

const WatermarkListContainer = styled.div``

type Props = {
    field: CreationToolSuperCutField
}

const CreationCaptureWatermarkPreviewField = ({ field }: Props) => {
    const { watermark, previousWatermarks } = useContext(CreationCaptureInfoContext)

    return (
        <>
            {previousWatermarks.length > 0 ? (
                <Container>
                    <FieldTitle field={field} />
                    <WatermarkListContainer>
                        {previousWatermarks.map((wm) => {
                            return (
                                <WatermarkPreviewItem
                                    key={wm.id}
                                    watermark={wm}
                                    currentlySelected={watermark?.imageUrl === wm.imageUrl}
                                />
                            )
                        })}
                    </WatermarkListContainer>
                </Container>
            ) : null}
        </>
    )
}

export default CreationCaptureWatermarkPreviewField
